<template>
    <div>
        <div>
            <b-breadcrumb>
                <b-breadcrumb-item :to="{ name: 'Home' }">Inicio</b-breadcrumb-item>
                <b-breadcrumb-item :to="{ name: 'Provider' }">Departamentos</b-breadcrumb-item>
                <b-breadcrumb-item v-if="$route.name !== 'Provider'">{{ $route.meta.title }}</b-breadcrumb-item>
            </b-breadcrumb>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
    }
</script>

<style scoped>

</style>
